import React from 'react';
import { StyledArticleHeading } from './styles';

export const ArticleHeading: React.FC<ArticleHeadingProps> = ({
  title,
  embedded = false,
}) =>
  embedded ? (
    <StyledArticleHeading as="h2">{title}</StyledArticleHeading>
  ) : (
    <StyledArticleHeading>{title}</StyledArticleHeading>
  );

interface ArticleHeadingProps {
  title: string;
  embedded?: boolean;
}
